import { render, staticRenderFns } from "./matrixheaderrequired.vue?vue&type=template&id=5d995022&"
import script from "./matrixheaderrequired.vue?vue&type=script&lang=ts&"
export * from "./matrixheaderrequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d995022')) {
      api.createRecord('5d995022', component.options)
    } else {
      api.reload('5d995022', component.options)
    }
    module.hot.accept("./matrixheaderrequired.vue?vue&type=template&id=5d995022&", function () {
      api.rerender('5d995022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrixheaderrequired.vue"
export default component.exports